import { Card, CardContent } from "@/components/ui/card"
import { ShieldBan } from "lucide-react";

const Unauthorized = () => {
    return (
        <div className="justify-center py-10 text-center">
            <Card className="max-w-full  justify-center">
                <CardContent className="justify-center text-center flex gap-1">
                    <ShieldBan className="w-8 h-8  text-red-500" />
                    <h1 className="font-outfit text-lg"> No tienes los permisos necesarios para realizar esta operación.</h1>
                </CardContent>
            </Card>
        </div>
    )
}

export default Unauthorized;